export default __webpack_public_path__ + "static/media/IPL.18e00f9b.png";